declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    gtag: any;
  }
}

export default class GoogleAnalyticsEvents {
  static loadResultPage(): void {
    window.gtag("event", "loadResultPage", { method: "Google" });
  }

  static loadHourSelection(): void {
    window.gtag("event", "loadHourSelection", { method: "Google" });
  }

  static loadUserIdentification(): void {
    window.gtag("event", "loadUserIdentification", { method: "Google" });
  }

  static loadUserRegister(): void {
    window.gtag("event", "loadUserRegister", { method: "Google" });
  }

  static loadAppointmentConfirmation(): void {
    window.gtag("event", "loadAppointmentConfirmation", { method: "Google" });
  }

  static serviceWithoutClinic(): void {
    window.gtag("event", "serviceWithoutClinic", { method: "Google" });
  }

  static allowLocation(): void {
    window.gtag("event", "allowLocation", { method: "Google" });
  }

  static dontAllowLocation(): void {
    window.gtag("event", "dontAllowLocation", { method: "Google" });
  }

  static useLocation(): void {
    window.gtag("event", "useLocation", { method: "Google" });
  }

  static searchLocation(): void {
    window.gtag("event", "searchLocation", { method: "Google" });
  }

  static scheduleAppointment(): void {
    window.gtag("event", "scheduleAppointment", { method: "Google" });
  }

  static returnHomePage(): void {
    window.gtag("event", "returnHomePage", { method: "Google" });
  }

  static newAppointment(): void {
    window.gtag("event", "newAppointment", { method: "Google" });
  }
}
